import Decimal from "decimal.js";

export interface Principal {
  id: string
  name: string
  email: string
  phone?: string
  picture?: string
  settings?: Record<string, any>
  roles: string[]
  acl: string[]
  suspendedAt?: string
  suspendedByIdentityId?: string
  createdAt: string
  lastActiveAt?: string
  eTag: string
}

export interface Client {
  id: string
  name?: string
  description?: string
  redirectUris: string[]
  grantTypes: string[]
  scopes: string[]
  roles: string[]
  acl: string[]
  accessAttributes: Record<string, string[]>
  createdAt: string
  lastActiveAt?: string
  eTag: string
}

export interface RoleListItem {
  key: string
  description?: string
  acl: string[]
  createdAt: string
  lastModifiedAt: string
  eTag: string
}

export interface Role extends RoleListItem {
  // Full role details (when needed)
  key: string
  memberCount: Decimal
  isSystem?: boolean
}

export interface Session {
  id: string
  type: string
  createdAt: string
  accessTokenExpiresAt: Date
  isCurrent: boolean
  isRevoked: boolean
  revokedAt?: string
  clientId?: string
  clientName?: string
  description?: string
}

export interface ClientSecret {
  id: string
  expiresAt: string
  revokedAt?: string
  description?: string
  isExpired: boolean
  isRevoked: boolean
}

export class IamApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message?: string,
  ) {
    super(message ?? '')
    this.name = 'IamApiError'
  }
}

// List query parameters
export type SortDirection = 'asc' | 'desc'

export interface PrincipalsListParams {
  name?: string
  email?: string
  roles?: string[]
  includeSuspended?: boolean
  after?: string
  before?: string
  limit?: number
  orderBy?: string
}

export interface ClientsListParams {
  type?: string
  includeSuspended?: boolean
  after?: string
  before?: string
  limit?: number
  orderBy?: string
}

export interface RolesListParams {
  includeSystem?: boolean
  after?: string
  before?: string
  limit?: number
  sortBy?: 'name' | 'description'
  sortDirection?: SortDirection
}

// List item for principal queries (from Graph API)
export interface PrincipalListItem {
  id: string
  name?: string
  email?: string
  phone?: string
  roles: string[]
  suspendedAt?: string
  lastActiveAt?: string
}

// List response types with pagination metadata
export interface PrincipalsListResponse {
  principals: PrincipalListItem[]
  lastCursor?: string
  firstCursor?: string
  totalCount: number
}

// List item for client queries (from Graph API)
export interface ClientListItem {
  id: string
  name?: string
  description?: string
}

export interface ClientsListResponse {
  clients: ClientListItem[]
  lastCursor?: string
  firstCursor?: string
  totalCount: number
}

export interface RolesListResponse {
  roles: Role[]
  hasMore: boolean
  lastCursor?: string
  firstCursor?: string
}
